import React from "react";
import { Box, Collapse, Group, Stack, Text, ThemeIcon, UnstyledButton } from "@mantine/core";
import { MSIcon } from "components";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";

export const NavButton = ({ chevron, chevronProps, icon, label, className, overrideClassName, active, ...rest }) => {
	return (
		<UnstyledButton
			className={
				overrideClassName ||
				`block  hover:bg-lightColor-0  dark:hover:bg-darkColor-2 rounded-md transition-colors  duration-300 ${
					className || ""
				}`
			}
			p={"0.35rem"}
			{...rest}
		>
			<Group justify="space-between" gap={0}>
				<Box style={{ display: "flex", alignItems: "center" }}>
					<ThemeIcon className="transition-all duration-300" variant={active ? "light" : "transparent"} size={35}>
						<MSIcon name={icon} size={"1.5rem"} />
					</ThemeIcon>
					<Text className="select-none " ms="md">
						{label}
					</Text>
				</Box>

				{chevron && <MSIcon size={"1rem"} {...chevronProps} />}
			</Group>
		</UnstyledButton>
	);
};
export const NavAccordion = ({ icon, label, opened: _opened, children, layer = 0, path }) => {
	const hasChildren = Array.isArray(children);
	const [opened, setOpened] = React.useState(_opened || false);
	const goTo = useNavigate();
	const location = useLocation();

	const activePath = location.pathname;
	const isActive = activePath === path;
	const spacing = layer > 0 && layer < 3 ? "1rem" : "0px";
	return (
		<>
			<NavButton
				onClick={() => {
					if (hasChildren) setOpened((o) => !o);
					else goTo(path);
				}}
				active={opened || isActive}
				icon={icon}
				label={label}
				style={{
					width: `calc(100% - (${layer}*${spacing}))`,
				}}
				mx={`calc(${spacing}*${layer})`}
				chevron={hasChildren}
				className={`${opened || isActive ? "!bg-lightColor-0 dark:!bg-darkColor-2 shadow-lg" : ""}`}
				chevronProps={{ name:"ChevronUp" ,className:`transition-transform duration-300 ${ opened ? "rtl:-rotate-180 ltr:rotate-180 " : "rtl:-rotate-90 ltr:rotate-90 " }` }} /* prettier-ignore */
			/>

			{hasChildren ? (
				<Collapse in={opened} mt={"0.25rem"}>
					<ListGroup items={children} layer={layer + 1} />
				</Collapse>
			) : null}
		</>
	);
};
const ListGroup = ({ items, layer }) => {
	return (
		<Stack gap="0.25rem">
			{items?.map?.((item, index) => {
				return <NavAccordion key={index} {...item} layer={layer} />;
			})}
		</Stack>
	);
};

export default ListGroup;
